import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../contexts/AuthContext";
import avatar from "../../../assets/images/avatar.jpeg";
import Style from "./index.module.css";

export const PerfilUsuario = () => {
  const navigate = useNavigate();
  const { user } = useAuth(); 

  const handleClick = () => {
    navigate("/perfil");
  };

  if (!user) return null; 

  return (
    <div className={Style.container} onClick={handleClick} style={{ cursor: "pointer" }}>
      <img
        src={user.foto || avatar} 
        alt="Foto do usuário"
        className={Style.avatar}
      />
      <div className={Style.info}>
        <span className={Style.nome}>{user.nomope.slice(0, 5) || ""}</span>
        <span className={Style.tipo}>{user.tipusu || ""}</span>
      </div>
    </div>
  );
};
